import { USER_STATUS } from 'utils/constants/roles';

export const activityTypeEnums = {
  startShift: 'START_SHIFT',
  endShift: 'END_SHIFT',
  startBreak: 'START_BREAK',
  endBreak: 'END_BREAK',
  startTask: 'START_TASK',
  endTask: 'END_TASK',
  // enterSite: 'ENTER_SITE',
  // exitSite: 'EXIT_SITE',
};
export const ATTENDANCE_TRACKING_SHIFT_STATUS = [
  {
    id: USER_STATUS.AVAILABLE.id,
    name: 'Available',
    multiOptions: [
      activityTypeEnums.startShift,
      activityTypeEnums.endBreak,
      activityTypeEnums.endTask,
    ],
  },
  {
    id: activityTypeEnums.startBreak,
    name: 'On Break',
  },
  {
    id: activityTypeEnums.startTask,
    name: 'On Task',
  },
  {
    id: activityTypeEnums.endShift,
    name: 'Unavailable',
  },
];
